<template>
    <header id="header">
        <div class="header">
            <logo />
            <div class="flex"></div>
            <navigation class="nav-desktop hide-mobile hide-tablet" />
            <i-tech-labs class="hide-mobile hide-tablet" />
            <lang />
            <social class="hide-mobile hide-tablet" />
            <div class="toggle-navigation hide-desktop hide-fullhd" @click="toggleNav" :class="{'active': navOpen}"><i class="icon-menu" /></div>
        </div>
        <navigation class="nav-mobile hide-desktop hide-fullhd" :open="navOpen" @closeNav="closeNav" />
    </header>
</template>

<script>
    import Logo from './logo.vue'
    import Navigation from './navigation.vue'
    import Lang from './lang.vue'
    import ITechLabs from './iTechLabs.vue'
    import Social from './social.vue'

    export default {
        name: 'AppHeader',
        components: {
            Logo,
            Navigation,
            Lang,
            ITechLabs,
            Social
        },
        data() {
            return {
                navOpen: false
            }
        },
        methods: {
            toggleNav() {
                this.navOpen = !this.navOpen;
            },
            closeNav() {
                this.navOpen = false;
            }
        }
    }
</script>

<style lang="scss">
    header {
        position: fixed;
        top: 0;
        display: block;
        width: 100%;
        height: $header-size;
        z-index: 100;

        .header {
            position: relative;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            height: 100%;
            padding: 0 $spacer/2;
            background: $white;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
            z-index: 1;
        }


        .toggle-navigation {
            width: 50px;
            height: 50px;
            font-size: 32px;
            line-height: 50px;
            text-align: center;
            cursor: pointer;
            order: 1;

            &.active {
                color: $primary;
            }
        }


        .logo,
        .navigation,
        .iTechLabs,
        .lang,
        .social {
            margin: 0 $spacer/2;
        }

        .logo {
            display: block;
            height: 100%;

            img {
                display: block;
                width: auto;
                height: 100%;
            }
        }

        .iTechLabs {
            .name,
            .sertificates { display: none;}
        }

        @media (max-width: ($desktop)-1) {
            height: $header-size-mobile;
        }


        .navigation.nav-mobile {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            height: 100%;
            padding-top: $header-size-mobile;
            background: $white;
            margin: 0;
            transform: translateY(-100%);
            transition: all 0.3s linear;
            overflow: hidden;

            .menu {
                height: 100%;
                overflow: auto;
                -webkit-overflow-scrolling: touch;

                .menu-item {
                    font-size: 3rem;

                    >a {
                        display: block;
                        padding: $spacer/2 $spacer;

                        i {
                            font-size: 2rem;
                            margin-left: $spacer/2;
                        }

                        &.router-link-active {
                            color: $white;
                            background: $primary;
                        }
                    }
                }

                .submenu-item {
                    font-size: 2rem;
  
                    >a {
                        display: block;
                        padding: $spacer/2 $spacer $spacer/2 $spacer*2;

                        &.router-link-active {
                            color: $primary;
                        }
                    }
                }
            }

            &.open {
                transform: translateY(0);
            }
        }


        .navigation.nav-desktop {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .menu {
                display: flex;
                align-items: stretch;

                .menu-item {
                    position: relative;

                    > a {
                        position: relative;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 50px;
                        border-radius: 25px;
                        margin: 0;
                        padding: $spacer;
                        font-size: 1.6rem;
                        color: $black;
                        background: transparent;
                        text-transform: uppercase;
                        white-space: nowrap;

                        i {
                            font-size: 1.4rem;
                            margin-left: $spacer/2;
                        }


                        &.router-link-active {
                            color: $white;
                            background: $primary;
                        }
                    }

                    &:hover > a {
                        color: $white;
                        background: $primary;
                    }

                    &.hasChildren:hover > a {
                        border-bottom-left-radius: 0;
                        border-bottom-right-radius: 0;
                        

                        ~.submenu {
                            display: block;
                        }
                    }
                }
            }

            .submenu {
                position: absolute;
                display: none;
                top: 100%;
                left: 0;
                min-width: 100%;
                margin: 0;
                padding:  0;
                background: rgba(0,0,0,0.7);

                .submenu-item {
                    position: relative;
                    display: block;
                    height: auto;
                    border-radius: 0;
                    margin: $spacer;
                    padding: 0;
                    font-size: 1.4rem;
                    color: $white;
                    background: transparent;
                    text-transform: uppercase;
                    white-space: nowrap;

                    a:hover,
                    a.router-link-active {
                        color: $primary;
                        background: transparent;
                    }
                }
            }
        }

        .lang {
            position: relative;
            display: block;

            .selected {
                display: block;
                width: auto;
                height: 50px;
                margin: 0;
                padding: $spacer;
                border-radius: 25px;
                border: 1px solid $grey;
                color: $black;
                font-size: 1.4rem;
                font-weight: bold;
                text-transform: uppercase;

                i {
                    font-size: 1.4rem;
                    font-weight: normal;
                    margin-left: $spacer/2;
                }
            }

            .dropdown {
                position: absolute;
                display: none;
                top: 100%;
                left: 0;
                min-width: 100%;
                padding: 0;
                margin: 0;
                background: rgba(0,0,0,0.7);

                .dropdown-item {
                    display: block;
                    padding: 0;
                    margin: $spacer;
                    font-size: 1.4rem;
                    color: $white;
                    text-transform: uppercase;
                    white-space: nowrap;
                    cursor: pointer;

                    &:hover,
                    &.active {
                        color: $primary;
                    }
                }
            }

            @media (max-width: ($desktop)-1) {
                &.open {
                    .selected {
                        border-bottom-left-radius: 0;
                        border-bottom-right-radius: 0;
                    }

                    .dropdown {
                        display: block;
                    }
                }
            }

            @media (min-width: $desktop) {
                &:hover {
                    .selected {
                        border-bottom-left-radius: 0;
                        border-bottom-right-radius: 0;
                    }

                    .dropdown {
                        display: block;
                    }
                }
            }
        }

        .social {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            h4 {
                display: none;
            }

            .social-item  {
                display: flex;
                justify-content: center;
                align-items: center;
                width:  50px;
                height:  50px;
                border-radius: 25px;
                font-size: 2rem;
                color: $white;
                padding: 0;
                margin: 0;

                & + .social-item {
                    margin-left: $spacer;
                }

                span {
                    font-size: 0;
                }

                i {
                    display: block;
                    text-align: center;
                }


                &.skype {
                    background-color: $skype;

                    &:hover {
                        background-color: darken($skype, 10);
                    }
                }

                &.whatsapp {
                    background-color: $whatsapp;
                
                    &:hover {
                        background-color: darken($whatsapp, 10);
                    }
                }

                &.email {
                    background-color: $email;

                     &:hover {
                        background-color: darken($email, 10);
                    }
                }
            }
        }
    }
</style>
